import { useMemo, useState } from 'react';
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from 'react-redux';
import { ComplexValue, LoadOptions } from 'app/types-shared';
import { ApplicationState } from 'app/types-store';
import { StatePathType } from 'app/constants';
import { actionCreatorsFactory } from './actions';
import { OptionsState } from './types';

const emptyList = [] as ComplexValue<number>[];

const useActionCreators = (statePath: StatePathType) => {
  const dispatch = useDispatch();
  return useMemo(
    () => bindActionCreators(actionCreatorsFactory(statePath), dispatch),
    [dispatch, statePath]
  );
};

export const useOptions = (
  statePath: StatePathType,
  id: string,
  endpoint: string,
  codetableId: number,
  params?: {
    loadOptionsParams?: LoadOptions,
    optionsParams?: any,
    optionsRequestPayload?: any
  }) => {

  const { loadOptions: loadOptionsAction } = useActionCreators(statePath);

  const [loadOptions, setLoadOptions] = useState<LoadOptions>();

  const onLoadOptions = (loadOptionsParams: LoadOptions) => {
    loadOptionsAction(id, endpoint,
      params?.loadOptionsParams ? { ...loadOptionsParams, ...params.loadOptionsParams } : loadOptionsParams,
      params?.optionsParams, params?.optionsRequestPayload, codetableId);
    setLoadOptions(loadOptionsParams);
  };

  const optionsState = useSelector<ApplicationState, OptionsState>(state => state[statePath]);

  const { codes: options = emptyList, fetching = false } = optionsState?.options?.[id] ?? {};

  return {
    options: options as ComplexValue<number>[],
    fetching,
    loadOptions,
    onLoadOptions
  };
};
